import { Button } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'

const buttonTypes = ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'none', 'dark', 'link']

export const TypographyPage = () => (
    <>
        <Helmet>
            <title>Typography</title>
        </Helmet>
        <div className="p-4">
            <h1>Buttons</h1>
            <div>
                {buttonTypes.map((buttonType) => (
                    <span>
                        <Button variant={buttonType}>{buttonType}</Button>{' '}
                    </span>
                ))}
            </div>
            <h1>Outline Buttons</h1>
            <div>
                {buttonTypes.map((buttonType) => (
                    <span>
                        <Button variant={`outline-${buttonType}`}>{buttonType}</Button>{' '}
                    </span>
                ))}
            </div>
            <h1>Heading 1</h1>
            <h2>Heading 2</h2>
            <h3>Heading 3</h3>
            <h4>Heading 4</h4>
            <h5>Heading 5</h5>
            <h6>Heading 6</h6>
            <ul>
                <li>Hello</li>
                <li>Man</li>
                <li>Woman</li>
            </ul>
            <ol>
                <li>First</li>
                <li>Second</li>
                <li>Third</li>
                <li>y</li>
                <li>y</li>
                <li>y</li>
                <li>y</li>
                <li>y</li>
                <li>y</li>
                <li>y</li>
            </ol>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <h1>Heading 1</h1>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <h2>Heading 2</h2>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <h6>Heading 6</h6>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <h3>Heading 3</h3>
            <ul>
                <li>Hello</li>
                <li>World</li>
            </ul>
            <h4>Heading 4</h4>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <ul>
                <li>Hello</li>
            </ul>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <ol>
                <li>Hello</li>
                <li>World</li>
            </ol>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
            <h5>Heading 5</h5>
            <ul>
                <li>Hello</li>
            </ul>
            <ol>
                <li>World</li>
            </ol>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce at mauris non magna dignissim ultrices.
                Pellentesque commodo dapibus ipsum, nec volutpat ante molestie in. Curabitur est velit, tincidunt vitae
                risus a, suscipit aliquam nibh.
            </p>
        </div>
    </>
)
